<script lang="ts">
	import FromFriendIcon from './FromFriendIcon.svelte';
	import FromGoogleIcon from './FromGoogleIcon.svelte';
	import LinkedInIcon from './FromLinkedInIcon.svelte';
	import FromOtherIcon from './FromOtherIcon.svelte';
	import SignalLowIcon from "./SignalLowIcon.svelte";
	import SignalMediumIcon from "./SignalMediumIcon.svelte";
	import SignalFullIcon from "./SignalFullIcon.svelte";
	import GraduationTamIcon from "./GraduationTamIcon.svelte";
	import PieChartIcon from "./PieChartIcon.svelte";
	import DesktopIcon from "./DesktopIcon.svelte";
	import PresentationIcon from "./PresentationIcon.svelte";
	import ClipboardIcon from "./ClipboardIcon.svelte";
	import SparklingIcon from "./SparklingIcon.svelte";

	export let type: string | 'linkedIn' | 'friend' | 'google' | 'other';
</script>

{#if type === 'linkedIn'}
	<LinkedInIcon />
{:else if type === 'friend'}
	<FromFriendIcon />
{:else if type === 'google'}
	<FromGoogleIcon />
{:else if type === 'other'}
	<FromOtherIcon />
{:else if type === 'beginner'}
	<SignalLowIcon />
{:else if type === 'intermediate'}
	<SignalMediumIcon />
{:else if type === 'advanced'}
	<SignalFullIcon />
{:else if type === 'student'}
	<GraduationTamIcon />
{:else if type === 'dataAnalyst'}
	<PieChartIcon />
{:else if type === 'product'}
	<DesktopIcon />
{:else if type === 'growth'}
	<PresentationIcon />
{:else if type === 'management'}
	<ClipboardIcon />
{:else if type === 'founder'}
	<SparklingIcon />
{:else}
	{type}
{/if}
